import { LucideIcon, HelpCircle, Briefcase, Award, Play, Building2, Mail } from 'lucide-react';

export interface MenuItem {
  href: string;
  label: string;
  icon?: LucideIcon;
  children?: MenuItem[];
}

export const menuItems: MenuItem[] = [
  { href: 'problems', label: 'お悩み', icon: HelpCircle },
  { href: 'services', label: 'サービス・料金', icon: Briefcase },
  { href: 'why', label: '選ばれる理由', icon: Award },
  { href: 'demo', label: '開発実績', icon: Play },
  { href: 'company', label: '会社概要', icon: Building2 },
  { href: 'contact', label: '無料相談', icon: Mail }
];
